import { useState, useEffect } from 'react'
import { Modal } from '@collegebacker/backer-ui/ui'
import classNames from 'classnames'

import styles from './TextEditModal.module.scss'

interface TextEditModalProps {
  text: string
  onConfirm: (value: string) => void
  onCancel: () => void
  isOpen: boolean
}

export const TextEditModal = (props: TextEditModalProps) => {
  const [value, setValue] = useState('')

  const handleCancel = () => {
    props.onCancel()
  }

  const onConfirm = () => {
    props.onConfirm(value.trim())
  }

  useEffect(() => {
    setValue(props.text)
  }, [props.text])

  return (
    <Modal
      className={styles.textEditModal}
      isOpen={props.isOpen}
      showCloseButton={false}
      onCloseClick={handleCancel}
      closeOnClickOutside={false}
      isBottomSheet
    >
      <div className={styles.controls}>
        <button
          className={classNames('typo-app-body-main', styles.button)}
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          className={classNames('typo-app-body-main', styles.button)}
          onClick={onConfirm}
        >
          Confirm
        </button>
      </div>
      <div className={styles.content}>
        <span className="typo-app-body-caption">Message:</span>
        <textarea
          autoFocus
          rows={4}
          className={classNames('typo-app-body-paragraph', styles.textarea)}
          onChange={(e) => setValue(e.target.value)}
          value={value}
        />
      </div>
    </Modal>
  )
}
